import StatusHeader from 'components/common/StatusHeader';
import { useHistory } from 'react-router-dom';
import AccordionDemo from './components/AccordionDemo';
import DemoMenuBookEditor from './components/DemoMenuBookEditor';
import DuplicationDisplayModal from './components/DuplicationDisplayModalDemo';
import GenreAddModalDemo from './components/GenreAddModalDemo';
import MenuAddModalDemo from './components/MenuAddModalDemo';
import ResetMobileOrderDisplayDemo from './components/ResetMobileOrderDisplayDemo';
import SelectSingleDepartmentDemo from './components/SelectSingleRestaurantDemo';
import SubGenreAddModalDemo from './components/SubGenreAddModalDemo';

function DemoFeature() {
  const history = useHistory();

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <StatusHeader onAction={() => history.push('/')} />
      </div>
      <div className="page-main">
        <div className="page-content d-flex flex-column">
          <section className="mb-5">
            <h3>Demo Accordion</h3>
            <AccordionDemo />
          </section>
          <section className="mb-5">
            <h3>Genre Add Modal Demo</h3>
            <GenreAddModalDemo />
          </section>
          <section className="mb-5">
            <h3>Sub Genre Add Modal Demo</h3>
            <SubGenreAddModalDemo />
          </section>
          <section className="mb-5">
            <h3>Menu Add Modal Demo</h3>
            <MenuAddModalDemo />
          </section>
          <section className="mb-5">
            <h3> Duplication Display Modal</h3>
            <DuplicationDisplayModal />
          </section>
          {/* <section className="mb-5">
            <h3>Demo open Popup MenuDetail</h3>
            <DemoPopupMenuDetailModal />
          </section> */}
          {/* <section className="mb-5">
            <h3>Demo open Popup submenu group Detail</h3>
            <OpenDialogSubMenuGroupDetail />
          </section> */}
          <section className="mb-5">
            <h3>Demo Error MenuBookEditor Auto popup MenuDetail</h3>
            <DemoMenuBookEditor />
          </section>
          <section className="mb-5">
            <h3>Reset MobileOrderDisplay Demo</h3>
            <ResetMobileOrderDisplayDemo />
          </section>
          <section className="mb-5">
            <h3>Demo Single Select Restaurant</h3>
            <SelectSingleDepartmentDemo />
          </section>
        </div>
      </div>
    </div>
  );
}

export default DemoFeature;
